export default __webpack_public_path__ + "static/LukeGromen-3b4c5d3fac6b068fb08c17f9e7cce9c9.jpg";